export default "__VITE_ASSET__CXCneKw8__"